import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { POSTS } from '../data/blog';

export default function BlogIndex() {
  const canonical = 'https://betterfenceanddeck.org/blog';
  return (
    <div className="bg-ink text-cream min-h-screen">
      <SEO
        title="Fence & Deck Guides | Better Fence & Deck Blog"
        description="Cost guides, material comparisons, and expert tips for fencing and deck projects across Shreveport, Bossier City, and the ArkLaTex."
        canonical={canonical}
      />
      <Navbar />

      <section className="pt-40 pb-12">
        <div className="max-w-5xl mx-auto px-5 md:px-8">
          <div className="eyebrow">The Better Blog</div>
          <h1 className="section-title">Fence &amp; deck guides for the ArkLaTex.</h1>
          <p className="section-lede">Straight-talk articles on cost, materials, permits, and timelines — written by the crew that builds them.</p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-6xl mx-auto px-5 md:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {POSTS.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group block rounded-md overflow-hidden bg-ink-panel border border-white/10 hover:border-gold/50 transition-colors">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.hero} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
              </div>
              <div className="p-5">
                <div className="flex flex-wrap gap-1.5 text-[10px] uppercase tracking-widest text-cream/60">
                  {p.tags.slice(0,2).map(t => <span key={t}>{t}</span>).reduce((a,b,i)=>[a,i&&<span key={'s'+i} className="text-gold">·</span>,b],[])}
                </div>
                <h2 className="mt-2 font-display uppercase text-xl text-cream tracking-tight group-hover:text-gold transition-colors">{p.title}</h2>
                <p className="mt-2 text-sm text-cream/65">{p.excerpt}</p>
                <div className="mt-3 flex items-center gap-1 text-xs text-cream/50"><Clock className="w-3 h-3" /> {p.readMinutes} min</div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
